import { RateLocationMapper } from "../rate-location/rate-location.mapper";
import { RateLocation } from "../rate-location/rate-location.type";
import { RateSurchargeBase } from "./rate-surcharge-base.model";
import { SurchargeType } from "../../surcharge-type/surcharge-type.model";
import { SurchargeTypeMapper } from "../../surcharge-type/surcharge-type.mapper";
import { ContainerPrices } from "../../shared/container/container-prices.model";

export class FclRateSurcharge extends RateSurchargeBase {
  constructor(
    protected id: number,
    protected discriminator: string,
    protected surchargeType: SurchargeType,
    protected rateOriginLocations: RateLocation[],
    protected rateDestinationLocations: RateLocation[],
    protected marginType: string,
    protected containers: ContainerPrices,
  ) {
    super(
      id,
      discriminator,
      surchargeType,
      rateOriginLocations,
      rateDestinationLocations,
    );
  }

  public getMarginType(): string {
    return this.marginType;
  }

  public setMarginType(marginType: string): void {
    this.marginType = marginType;
  }

  public getContainers(): ContainerPrices {
    return this.containers;
  }

  public getClone(): FclRateSurcharge {
    return new FclRateSurcharge(
      this.getId(),
      this.getDiscriminator(),
      SurchargeTypeMapper.map(this.getSurchargeType()),
      this.getRateOriginLocations()
        ? this.getRateOriginLocations().map(RateLocationMapper.map)
        : [],
      this.getRateDestinationLocations()
        ? this.getRateDestinationLocations().map(RateLocationMapper.map)
        : [],
      this.marginType,
      new ContainerPrices(this.getContainers().getRequestParams()),
    );
  }
}
